import styled from 'styled-components'

import theme, { breakpoint } from 'style/theme'

export default styled.div`
  display: flex;
  align-items: center;

  .left-block {
    flex: 1;

    .content-left-block {
      width: 60%;
      .image-logo {
        width: 200px;
      }
      .detail {
        margin: 30px 0;
        .ant-typography {
          color: ${theme.mediumGray};
        }
      }
      .button-block {
        display: flex;
        button {
          box-shadow: 0 0 20px 0 rgba(226, 64, 54, 0.2);
        }
      }
    }
  }

  .right-block {
    flex: 1;
    .button-block {
      display: none;
    }
    .image-block {
      border: 5px solid ${theme.darkRed};
      border-radius: 10px;
      background: ${theme.darkRed};
    }
  }

  @media (max-width: ${breakpoint.md}) {
    flex-direction: column;

    .left-block {
      .content-left-block {
        width: 100%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        .image-logo {
          width: 170px;
        }

        .button-block {
          display: none;
        }
      }
    }

    .right-block {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      .button-block {
        display: block;
        margin-top: 40px;
      }
    }
  }
`
